var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#" + _vm.clipId + ")" } }, [
        _c("path", {
          attrs: {
            d:
              "M16.52 5.65039L13.42 3.25039C13.02 2.85039 12.12 2.65039 11.52 2.65039H7.71998C6.51998 2.65039 5.21998 3.55039 4.91998 4.75039L2.51998 12.0504C2.01998 13.4504 2.91998 14.6504 4.41998 14.6504H8.41998C9.01998 14.6504 9.51998 15.1504 9.41998 15.8504L8.91998 19.0504C8.71998 19.9504 9.31998 20.9504 10.22 21.2504C11.02 21.5504 12.02 21.1504 12.42 20.5504L16.52 14.4504",
            stroke: _vm.color,
            "stroke-width": "1.5",
            "stroke-miterlimit": "10"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M21.62 5.65V15.45C21.62 16.85 21.02 17.35 19.62 17.35H18.62C17.22 17.35 16.62 16.85 16.62 15.45V5.65C16.62 4.25 17.22 3.75 18.62 3.75H19.62C21.02 3.75 21.62 4.25 21.62 5.65Z",
            stroke: _vm.color,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        })
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: _vm.clipId } }, [
          _c("rect", { attrs: { width: "24", height: "24", fill: "white" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }